import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "./../LeagueGroups.css";
import LocationCount from "./LocationCount/LocationCount";
import "./ScheduleOverview.css";
import TimeCount from "./TimeCount/TimeCount";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { COLORS, TBD } from "../../../../../../../Util/helper";
import { config } from "../../../../../../../config";
import _ from "lodash";
import getSearchParam from "../../../../../../../hooks/UrlSearchParam";
import moment from 'moment';

function ScheduleOverview(props) {

  const [leagueId, setLeagueId] = useState(0);
  const [matchup, setMatchup] = useState({});
  const [scheduleData, setScheduleData] = useState({});
  const [locationCount, setLocationCount] = useState({});
  const [timeCount, setTimeCount] = useState({});
  const [selectedTab, setSelectedTab] = useState('t')
  const [tbdFields, setTBD] = useState({})
  
  useEffect(() => {
    const leagueId_ = getSearchParam(props.location).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      getLeagueInfo();
      getScheduleOverview();
    }
    //eslint-disable-next-line
  }, [leagueId]);

  const getLeagueInfo = () => {
    axiosApi.get(`${config.apiUrl}/leagues/time/team/location/field/${leagueId}`)
      .then((response) => {
        if (response.data && response.data.teamData) {
          response.data.teamData = response.data.teamData.map((v, i) => ({ ...v, color: COLORS[i], title: v.name }))
        }
        setMatchup(response.data);
        
        if (response.data?.tbd) {
          setTBD(response.data.tbd);
        }
      })
      .catch((err) => {
      })
  }

  const getScheduleOverview = () => {
    axiosApi.get(`${config.apiUrl}/leagues/active/overview/${leagueId}`)
      .then((response) => {
        if (response.data && response.data.data) {
          response.data.data.forEach(element => {
            element.date = moment(element.date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            element.time = moment(element.time, 'HH:mm').format('hh:mm A')
          });
        }
        let data = [...response.data.data];
        data = _.mapValues(_.groupBy(data, 'week'),
          list => list.map(x => _.omit(x, 'week')));
        setScheduleData(data);

        const teams = [...new Set([...response.data.data.map(x => x.team1_id), ...response.data.data.map(x => x.team2_id)])];
        if (teams) {
          let teamGrouping = [];
          teams.forEach(val => {
            teamGrouping = {
              ...teamGrouping,
              ...{[val]: response.data.data.filter(x => (+x.team1_id === +val || +x.team2_id === +val))}
            }
          })
          const lCount = _.mapValues(teamGrouping,
            list => list.map(x => x.location_id).reduce((acc, o) => {
              acc[o] = (acc[o] || 0) + 1;
              return acc;
            }, {}));


          setLocationCount(lCount);

          const tCount = _.mapValues(teamGrouping,
            list => list.map(x => x.time).reduce((acc, o) => {
              acc[o] = (acc[o] || 0) + 1;
              return acc;
            }, {}));
          setTimeCount(tCount);
        }
      })
      .catch((err) => {
      })
  }

  const colorCode = (id) => {
    let color = '';
    if (id && matchup && matchup.teamData) {
      color = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).color : '';
    }
    return color;
  }

  const teamName = (id) => {
    let name = '--';
    if (id && matchup && matchup.teamData) {
      name = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).name : '--';
    }
    return name;
  }

  const fieldName = (id, parent_id) => {
    let name = '';
    if (id && matchup && matchup.fields) {
      name = matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)) ? matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)).title : '';
      if(id === tbdFields.id) {
        name = tbdFields.title;
      }
    }
    return name;
  }

  return (
    <>
      <div className="schedule-overview schedule-overview-change">
        {
          !_.isEmpty(scheduleData) &&
          matchup &&
          !_.isEmpty(matchup) &&
          matchup.teamData &&
          <div className="count-blk">
            <div className="tabs-wrapper">
              <div className="tabs-innerWrapper">
                <p className={(selectedTab === 't') ? 'active' : ''} onClick={() => setSelectedTab('t')}>
                  Time Count
                </p>
                <p className={(selectedTab === 'l') ? 'active' : ''} onClick={() => setSelectedTab('l')}>
                  Location Count
                </p>
              </div>
            </div>
            {
              selectedTab === 't' &&
              <TimeCount matchup={matchup} timeCount={timeCount} />
            }
            {
              selectedTab === 'l' &&
              <LocationCount matchup={matchup} locationCount={locationCount} />
            }
          </div>
        }

        <div className="matchup-blk">
          {/* <div className="matchup-header">
            <h2>Matchups</h2>
            <button className="btn">Add Rainout</button>
          </div> */}
          <div className="matchup-body">
            {
              scheduleData &&
              !_.isEmpty(scheduleData) &&
              matchup &&
              !_.isEmpty(matchup) &&
              Object.keys(scheduleData).map((key, index) => (
                <div className="week-blk" key={`${key}-${index}`}>
                  <h3>{`Week ${key}`}</h3>
                  <div className="week-body">
                    {
                      scheduleData[key].map((val, i) => (
                        <div className="inner-wrapper" key={i}>
                          <div className="score-blk">
                            <div className="row">
                              <div className="left">
                                <span>
                                  {teamName(val.team1_id)}
                                </span>
                                <div className="dock-icon" style={{ background: colorCode(val.team1_id) }}></div>
                              </div>
                              <div className="right">
                                <span>
                                  {
                                    val && ((e) => {
                                      if (e.team1_forfeit) {
                                        return <font style={{ color: 'red' }}>F</font>
                                      } else {
                                        return e.team1_score || e.team1_score === 0 ? e.team1_score : ''
                                      }
                                    })(val)
                                  }
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="left">
                                <span>
                                  {teamName(val.team2_id)}
                                </span>
                                <div className="dock-icon" style={{ background: colorCode(val.team2_id) }}></div>
                              </div>
                              <div className="right">
                                <span>
                                  {
                                    val && ((e) => {
                                      if (e.team2_forfeit) {
                                        return <font style={{ color: 'red' }}>F</font>
                                      } else {
                                        return e.team2_score || e.team2_score === 0 ? e.team2_score : ''
                                      }
                                    })(val)
                                  }
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="time-blk">
                            <div className="row">
                              <span>{val.date}</span>
                              <span className="divider">-</span>
                              {
                                (val.field_id && fieldName(val.field_id, val.location_id) != 'TBD') || !val.field_id ?
                                 <span>{TBD.value.includes(val.time) ? TBD.name : val.time}</span>
                                 : 
                                 <span>TBD</span>
                              }
                            </div>
                            <div className="row">
                              <span className="label">Field:</span>
                              <span>{val.field_id ? fieldName(val.field_id, val.location_id) : TBD.name}</span>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(ScheduleOverview);
